import { AI_USES } from "../data/site";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export const PracticalAI = () => (
    <section id="ai" className="girder-grid-light bg-brand-brown py-16 sm:py-24 lg:py-32" data-testid="ai-section">
        <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
            <SectionHeading
                dark
                chapter="06"
                kicker="Practical AI"
                title="AI that does the heavy lifting — quietly."
                lead="No 'revolutionary' buzzwords. We use AI where it genuinely saves time and sharpens the work, inside a system a human oversees."
                testid="ai-heading"
            />
            <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
                {AI_USES.map((use, i) => (
                    <Reveal key={use.title} delay={(i % 3) * 0.08}>
                        <article
                            data-testid={`ai-card-${i}`}
                            className="h-full rounded-2xl border border-brand-cream/15 bg-brand-brown-deep p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-brand-orange/50"
                        >
                            <span className="font-mono text-xs font-semibold text-brand-orange">
                                {String(i + 1).padStart(2, "0")}
                            </span>
                            <h3 className="mt-4 font-display text-xl font-bold text-brand-paper">{use.title}</h3>
                            <p className="mt-3 text-sm leading-relaxed text-brand-cream/70">{use.text}</p>
                        </article>
                    </Reveal>
                ))}
            </div>
            <Reveal delay={0.1}>
                <p className="mt-10 max-w-2xl border-l-2 border-brand-orange pl-5 text-sm leading-relaxed text-brand-cream/75 sm:text-base">
                    Every AI-assisted output that represents your business is reviewed for accuracy and tone first. AI is a
                    tool inside the system — never the product.
                </p>
            </Reveal>
        </div>
    </section>
);
